import React from 'react';
import { BookOpen, Target, Flame, Calendar } from 'lucide-react';
import { getDaysUntilInterviewSeason } from '../utils/dateUtils';
import './Dashboard.css';

interface DashboardProps {
  totalProblemsSolved: number;
  currentStreak: number;
  onResourceLibraryClick: () => void;
  weekProgress: {
    completed: number;
    total: number;
  };
}

export const Dashboard: React.FC<DashboardProps> = ({
  totalProblemsSolved,
  currentStreak,
  onResourceLibraryClick,
  weekProgress
}) => {
  const daysUntilInterviews = getDaysUntilInterviewSeason();
  const progressPercentage = (weekProgress.completed / weekProgress.total) * 100;

  return (
    <div className="dashboard">
      <div className="stats-grid">
        <div className="stat-card">
          <Target className="stat-icon" style={{ color: '#2196F3' }} />
          <div className="stat-content">
            <div className="stat-value">{totalProblemsSolved}/500</div>
            <div className="stat-label">Problems Solved</div>
          </div>
        </div>
        
        <div className="stat-card">
          <Flame className="stat-icon" style={{ color: '#FF6B6B' }} />
          <div className="stat-content">
            <div className="stat-value">{currentStreak} days</div>
            <div className="stat-label">Current Streak</div>
          </div>
        </div>
        
        <div className="stat-card">
          <Calendar className="stat-icon" style={{ color: '#4CAF50' }} />
          <div className="stat-content">
            <div className="stat-value">{daysUntilInterviews} days</div>
            <div className="stat-label">Until Interview Season</div>
          </div>
        </div>
        
        <div className="stat-card">
          <BookOpen className="stat-icon" style={{ color: '#9C27B0' }} />
          <div className="stat-content">
            <button onClick={onResourceLibraryClick} className="resource-button">
              Resource Library
            </button>
          </div>
        </div>
      </div>
      
      <div className="phase-progress">
        <div className="progress-header">
          <span>Week Progress</span>
          <span>{weekProgress.completed}/{weekProgress.total} tasks</span>
        </div>
        <div className="progress-bar">
          <div 
            className="progress-fill" 
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      </div>
    </div>
  );
};